/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1543457b7bddf6bb493ec03644095ab0>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const EpicIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M6 15.25h-.75a.75.75 0 0 0 1.304.505zm7.75-8.5.554.505a.75.75 0 0 0-.407-1.24zM10 6h-.75v.615l.603.12zm0-5.25h.75A.75.75 0 0 0 9.446.245zm-7.75 8.5-.554-.505a.75.75 0 0 0 .407 1.24zM6 10h.75v-.615l-.603-.12zm.554 5.755 7.75-8.5-1.108-1.01-7.75 8.5zm7.343-9.74-3.75-.75-.294 1.47 3.75.75zM10.75 6V.75h-1.5V6zM9.446.245l-7.75 8.5 1.108 1.01 7.75-8.5zm-7.343 9.74 3.75.75.294-1.47-3.75-.75zM5.25 10v5.25h1.5V10z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
EpicIcon.displayName = 'EpicIcon';
var _default = exports.default = EpicIcon;